import { useGlobalContext } from 'src/contexto/contextoGlobal'
import BottomFixed from '../../components/bottomFixed'
import Footer from '../../components/footer'
import Header from '../../components/header/index'
import InnerHead, { DEFAULT_TITLE } from '../../components/innerHead'
import MenuCategorias from '../../components/menuCategorias'
import { OriginLoadingEnum } from 'src/util/enums/origin-loading'
import { LoadingSearchCategorySkeleton } from '../loadingSearchCategorySkeleton'

type LayoutProps = {
  children: React.ReactNode
  linxMeta?: string
  whatsAppPopup?: boolean
  title?: string
  description?: string
  pageTopButton?: boolean
  hotsite?: {
    showNewsletter: boolean
    showMenuCategory: boolean
    initialColor: string
    finalColor: string
    buttonColor: string
    baseColor: string
    textColor: string
  }
}

export default function Layout({
  children,
  linxMeta = '',
  whatsAppPopup = false,
  title = DEFAULT_TITLE,
  description = undefined,
  pageTopButton = false,
  hotsite = {
    showNewsletter: true,
    showMenuCategory: true,
    initialColor: '',
    finalColor: '',
    buttonColor: '',
    baseColor: '',
    textColor: '',
  },
}: LayoutProps) {
  const { originLoading } = useGlobalContext()

  const origins = [OriginLoadingEnum.SEARCH, OriginLoadingEnum.CATEGORY]
  const content = origins.includes(originLoading!) ? (
    <LoadingSearchCategorySkeleton
      isCategoryPage={originLoading === OriginLoadingEnum.CATEGORY}
    />
  ) : (
    children
  )

  return (
    <div>
      <InnerHead
        linxMeta={linxMeta}
        title={title}
        description={description}
        hasRobots
      />
      <Header
        initialColor={hotsite.initialColor}
        finalColor={hotsite.finalColor}
        textColor={hotsite.textColor}
        buttonColor={hotsite.buttonColor}
        baseColor={hotsite.baseColor}
        buttonCartTextColor={hotsite.textColor}
      />
      {hotsite.showMenuCategory && <MenuCategorias />}
      {content}
      <Footer
        showNewsletter={hotsite.showNewsletter}
        initialColor={hotsite.initialColor}
        finalColor={hotsite.finalColor}
        buttonColor={hotsite.buttonColor}
        textColor={hotsite.textColor}
      />
      <BottomFixed
        whatsAppPopup={whatsAppPopup}
        pageTopButton={pageTopButton}
        colorTopButton={hotsite.baseColor}
      />
    </div>
  )
}
